import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { FormError } from '@components/form-error';

import { useStore } from 'models/stores';
import Checkbox from 'shared/elements/Checkbox';

export default observer(({ form }) => {
  const {
    uiStore: { language, t },
    companyStore: { current },
  } = useStore();
  const hasCompanyPolicyUrl = !!current.privacyPolicyUrl;
  return (
    <Wrapper>
      <div>
        <Checkbox
          checked={form.termsAccepted}
          onClick={form.disabled ? null : form.toggleAcceptTerms}
          disabled={form.disabled}
          error={form.termsError}
          dataCy="accept-terms"
        />
        <div>
          {t('accept_terms_body_text')}
          <a href="https://privacy.50skills.com/" target="_blank" rel="noopener noreferrer">
            {t('fifty_privacy_policy')}
            {!hasCompanyPolicyUrl && '.'}
          </a>
          {hasCompanyPolicyUrl && t('privacy_policy_and')}
          {hasCompanyPolicyUrl && (
            <a href={current.privacyPolicyUrl} target="_blank" rel="noopener noreferrer">
              {` ${t(
                'company_privacy_policy',
                current.possessiveForm(language) || current.companyName || current.name,
              )}.`}
            </a>
          )}
        </div>
      </div>
      {form.termsError && (
        <ErrorWrapper>
          <FormError text={t('terms_agreement_required')} />
        </ErrorWrapper>
      )}
    </Wrapper>
  );
});

const Wrapper = styled.div`
  width: 100%;
  max-width: 448px;
  margin: 0 auto;
  font-size: 14px;
  color: ${(p) => p.theme.textColor};

  > div:nth-child(1) {
    display: flex;
    align-items: center;

    a {
      opacity: 1;
      :hover {
        opacity: 0.65;
      }
    }

    > div:nth-child(1) {
      margin-right: 8px;
    }
  }
`;

const ErrorWrapper = styled.div`
  margin-top: 8px;
`;
